import StorageManager from '../storage'

import {
  isEmpty
} from 'lodash'

import {
  isBetGroupsValid,
  logger
} from '../../utils'

const BETS_STORAGE_KEY = 'bets'

export default class BetStorageManager {
  /*
    Fetching events data from stored bet items and adding it to betslip
  */
  async resolveBetItems () {
    try {
      const betsIdsFromStorage = JSON.parse(
        await StorageManager.getItem(BETS_STORAGE_KEY)
      )

      if (isEmpty(betsIdsFromStorage)) {
        return []
      }

      const betItems = betsIdsFromStorage.filter(bet => (
        bet.eventId &&
        bet.outcomeId &&
        bet.marketTypeId &&
        bet.marketId &&
        isBetGroupsValid(bet.betGroups)
      ))

      await StorageManager.setItem(
        BETS_STORAGE_KEY,
        JSON.stringify(betItems)
      )

      return betItems
    } catch (error) {
      // If the stored value broken - cleaning storage and stoping exec
      logger.warn(
        '[betstorage]',
        'unable to resolve bets from storage:',
        error.message
      )

      await this.removeAllBetItems()
      return []
    }
  }

  /*
    Add main information about event to storage
    for restoring events in betslip after reloading the page
  */
  getValidBets (bets) {
    return bets.reduce(
      (acc, bet) => {
        const {
          eventId,
          outcomeId,
          marketTypeId,
          marketId,
          betGroups,
          betEventType,
          isBespokeOutcome,
          /**
           * For grouping bet items in betslip by type (single, same game multi, etc.)
           */
          betSlipGroup
        } = bet

        if (eventId && outcomeId && marketTypeId && marketId && isBetGroupsValid(betGroups)) {
          return [
            ...acc,
            { eventId, outcomeId, marketTypeId, marketId, betGroups, betEventType, betSlipGroup, isBespokeOutcome }
          ]
        }

        return acc
      },
      []
    )
  }

  async setBetItems (bets) {
    const validBetItems = this.getValidBets(bets)
    return StorageManager.setItem(
      BETS_STORAGE_KEY,
      JSON.stringify(validBetItems)
    )
  }

  /*
    Clean up all information about bets from storage
  */
  async removeAllBetItems () {
    return StorageManager.removeItem(BETS_STORAGE_KEY)
  }
}
